var _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFollowOption(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 1C6.38338 1 1 6.38292 1 13C1 19.6171 6.38338 25 13 25C19.6166 25 25 19.6171 25 13C25 6.38292 19.6166 1 13 1Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9671 12.6559L14.0357 8.72361C14.042 8.36164 13.7537 8.06308 13.3918 8.05678C13.0298 8.05047 12.7313 8.33876 12.725 8.70073L12.6563 12.6331L8.72393 12.5644C8.36196 12.5581 8.06342 12.8464 8.05711 13.2084C8.05081 13.5703 8.33913 13.8689 8.70105 13.8752L12.6334 13.9438L12.5648 17.8762C12.5585 18.2381 12.8468 18.5367 13.2087 18.543C13.5707 18.5493 13.8692 18.261 13.8755 17.8991L13.9442 13.9667L17.8765 14.0353C18.2385 14.0417 18.537 13.7534 18.5434 13.3914C18.5497 13.0294 18.2614 12.7309 17.8994 12.7246L13.9671 12.6559Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_243_10048",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 11,
    height: 11
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9671 12.6559L14.0357 8.72361C14.042 8.36164 13.7537 8.06308 13.3918 8.05678C13.0298 8.05047 12.7313 8.33876 12.725 8.70073L12.6563 12.6331L8.72393 12.5644C8.36196 12.5581 8.06342 12.8464 8.05711 13.2084C8.05081 13.5703 8.33913 13.8689 8.70105 13.8752L12.6334 13.9438L12.5648 17.8762C12.5585 18.2381 12.8468 18.5367 13.2087 18.543C13.5707 18.5493 13.8692 18.261 13.8755 17.8991L13.9442 13.9667L17.8765 14.0353C18.2385 14.0417 18.537 13.7534 18.5434 13.3914C18.5497 13.0294 18.2614 12.7309 17.8994 12.7246L13.9671 12.6559Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_243_10048)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2 -2H28.6V28.6H-2V-2Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFollowOption);
export default __webpack_public_path__ + "static/media/icFollowOption.a40521766fc32fc7e904647393424ae5.svg";
export { ForwardRef as ReactComponent };